import { useEffect } from 'react';
import useCheckAuth from './useCheckAuth';
var emptyParams = {};
/**
 * Restrict access to authenticated users.
 * Redirect anonymous users to the login page.
 *
 * Use it in your custom page components to require
 * authentication.
 *
 * You can set additional `authParams` at will if your authProvider
 * requires it.
 *
 * @example
 *     import { useAuthenticated } from 'react-admin';
 *     const FooPage = () => {
 *         useAuthenticated();
 *         return <Foo />;
 *     }
 *     const CustomRoutes = [
 *         <Route path="/foo" render={() => <FooPage />} />
 *     ];
 *     const App = () => (
 *         <Admin customRoutes={customRoutes}>
 *             ...
 *         </Admin>
 *     );
 */
export default (function (params) {
    if (params === void 0) { params = emptyParams; }
    var checkAuth = useCheckAuth();
    useEffect(function () {
        checkAuth(params).catch(function () { });
    }, [checkAuth, params]);
});
